/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { Form } from 'react-final-form';
import {
 dlsBrightBlue, Heading, GlyphLeft, ButtonPrimary, ButtonSecondary, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
// eslint-disable-next-line no-unused-vars
import UpdatePasswordChildForm from './UpdatePasswordChildForm';
import { getTrimmedObjectValues, useValidationSchema } from 'axp-fx-common';
import { updatePasswordValidationschema } from '../../../utils/updatePasswordValidation';
import labels from '../../../constants/labels';

const UpdatePasswordForm = ({
  selectedFxAccount,
  setStepNo,
  setUpdatePasswordStepNo,
  setUpdatedFxAccount,
  actionButtonLabelTxt,
  action,
}) => {
  const validate = useValidationSchema(updatePasswordValidationschema);

  const handleUpdatePasswordSubmit = (values) => {
    setUpdatedFxAccount(values);
    setUpdatePasswordStepNo(2);
  };

  return (
    <>
      <div className="flex flex-align-center stack-r margin-2-t">
        <GlyphLeft
          role="button"
          theme={dlsBrightBlue}
          size="lg"
          title="Previous step icon"
          onClick={() => setStepNo(1)}
        />
        <Heading level={2} headingStyle="heading5">
          {`${labels.FX_ACCOUNT_NAME}: ${selectedFxAccount.fxAccountName}`}
        </Heading>
      </div>
      <Form
        validate={validate}
        onSubmit={(formValues) => handleUpdatePasswordSubmit(getTrimmedObjectValues(formValues))}
        initialValues={selectedFxAccount}
        render={({
 handleSubmit, valid, submitting, form,
}) => (
  <form onSubmit={handleSubmit}>
    <div className="flex flex-column margin-4-tb stack">
      <div className="stack">
        <UpdatePasswordChildForm form={form} action={action} />
      </div>
      <div className="text-align-right" css={{ marginTop: '150px' }}>
        <ButtonSecondary id="cancel-table" className="margin-responsive-r" onClick={() => setStepNo(1)}>
          Cancel
        </ButtonSecondary>
        <ButtonPrimary type="submit" disabled={!valid || submitting}>
          {actionButtonLabelTxt}
        </ButtonPrimary>
      </div>
    </div>
  </form>
        )}
      />
    </>
  );
};

UpdatePasswordForm.propTypes = {
  selectedFxAccount: PropTypes.shape({
    fxAccountName: PropTypes.string.isRequired,
  }).isRequired,
  setStepNo: PropTypes.func.isRequired,
  setUpdatePasswordStepNo: PropTypes.func.isRequired,
  setUpdatedFxAccount: PropTypes.func.isRequired,
  actionButtonLabelTxt: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default UpdatePasswordForm;
